import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ExportToCsv } from 'export-to-csv';
import {
  Button,
} from '../../../components/index';
import {
  doGet,
} from '../../../utils/requests';

class RelatorioFilaPrisma extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  tratarSucessoListaExportacao = (response) => {
    if (response.data !== '') {
      this.setState({
      }, this.gerarCsv(response.data));
    }
  };

  tratarErro = () => {
    // const mensagemPrimaria = 'Não foi possível consultar a fila do Prisma.';
    // const mensagemSecundaria = 'Contate o administrador do sistema.';
    this.setState({
    });
  };

  colunasExportacaoDefault = [
    'CPF',
    'Espécie',
    'motivo PRISMA',
    'Data de Recebimento PRISMA',
    'Data de Envio COMPREV',
    'Número do Benefício',
    'Resultado',
  ];

defineListaParaExportacao = (lista) => {
  const listaOriginal = lista;
  const resultado = [];
  listaOriginal.forEach((item) => {
    resultado.push({
      cpf: item.cpf ? item.cpf : '',
      especie: item.especie ? item.especie : '',
      motivoPrisma: item.motivoPrisma ? item.motivoPrisma : '',
      dtRecibementoPrisma: item.dtRecibementoPrisma ? item.dtRecibementoPrisma : '',
      dtEnvioComprev: item.dtEnvioComprev ? item.dtEnvioComprev : '',
      nb: item.nb ? item.nb : '',
      resultado: item.resultado ? item.resultado : '',
    });
  });

  return resultado;
};

exportar = () => {
  if (Object.entries(this.props.filtrosConsulta).length !== 0) {
    doGet(
      'beneficios-prisma/exportacao-csv',
      this.tratarSucessoListaExportacao,
      this.tratarErro,
      {
        ...this.props.filtrosConsulta,
      },
    );
  }
};

gerarCsv = (lista) => {
  let dadosRelatorio = null;
  const legenda = 'Fila de migração do PRISMA';

  if (lista && lista !== undefined && lista.length > 0) {
    dadosRelatorio = this.defineListaParaExportacao(lista);
  } else {
    dadosRelatorio = [];
  }


  if (dadosRelatorio && dadosRelatorio !== undefined && dadosRelatorio.length > 0) {
    const csvExporter = new ExportToCsv({
      filename: 'Fila de migração do PRISMA',
      fieldSeparator: ';',
      showTitle: true,
      title: legenda,
      showLabels: true,
      headers: this.colunasExportacaoDefault,
    });
    csvExporter.generateCsv(dadosRelatorio);
  }
}

render() {
  return (
    <React.Fragment>
      <div className="row">
        <Button
          hint="Exportar para CSV"
          onClick={() => { this.exportar(); }}
          icon="ico-doc-sheet"
          mini
        />
      </div>
    </React.Fragment>
  );
}
}

RelatorioFilaPrisma.propTypes = {
  voltarAction: PropTypes.func,
  filtrosConsulta: PropTypes.object,
}.isRequired;

RelatorioFilaPrisma.defaultProps = {
  voltarAction: () => null,
};

export default RelatorioFilaPrisma;



// WEBPACK FOOTER //
// ./src/pages/consultas/exportacao-csv/RelatorioFilaPrisma.jsx